<div [hidden]="!isLoading" class="splash-screen-loader">
  <span class="shadowSpin"></span>
  <p>LOADING</p>
</div>

